import i18next from 'i18next';

import {
  GENERIC_MODAL_CANCEL_BUTTON,
  GENERIC_MODAL_SAVE_BUTTON,
} from '@commons/Modals/GenericModal/genericModalActions';

import GroupsAndStoresSelectionModal from '@commons/Modals/GroupsAndStoresSelectionModal';

const MODAL_WIDTH = '600px';
const MODAL_CONTENT_PADDING = '24px';

export const getAddToProductionModalConfig = ({
  stores,
  selectedStores,
  setSelectedStores,
  handleSave,
  handleCloseCleanUp,
}) => ({
  type: 'action',
  width: MODAL_WIDTH,
  height: 'auto',
  icon: '/images/inpulse/add-black-small.svg',
  title: i18next.t('ADMIN.RECIPES.ADD_TO_PRODUCTION'),
  customPadding: MODAL_CONTENT_PADDING,
  applyOverflow: false,
  handleCloseCleanUp,
  component: GroupsAndStoresSelectionModal,
  data: {
    introText: i18next.t('ADMIN.RECIPES.ADD_TO_PRODUCTION_MODAL_INFO'),
    storesLabel: i18next.t('ADMIN.RECIPES.ADD_TO_PRODUCTION_STORES_LABEL'),
    groups: [],
    stores,
    selectedStores,
    setSelectedStores,
  },
  actions: [
    GENERIC_MODAL_CANCEL_BUTTON(),
    {
      ...GENERIC_MODAL_SAVE_BUTTON(),
      isDisabled: !selectedStores.length,
      handleClick: handleSave,
      preventClosing: true,
    },
  ],
});
